import { useState, useEffect } from 'react';
import { Brain, X } from 'lucide-react';

interface NewKbModalProps {
  onConfirm: (name: string) => void;
  onClose: () => void;
}

export function NewKbModal({ onConfirm, onClose }: NewKbModalProps) {
  const [name, setName] = useState('');

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-surface-raised rounded-xl border border-border w-full max-w-md p-6 shadow-2xl">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-base font-semibold text-text-primary">Nowa baza wiedzy</h3>
          <button onClick={onClose} className="p-1 text-text-secondary hover:text-text-primary rounded-lg hover:bg-surface-hover transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <p className="text-xs text-text-muted mb-4">
          Nazwij bazę wiedzy (np. grupa docelowa, kąt marketingowy).
        </p>
        <input
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="np. Kobiety 30-50, Sportowcy, Domyślna..."
          className="w-full px-3 py-2.5 bg-surface-hover border border-border rounded-lg text-text-primary text-sm focus:outline-none focus:border-accent-primary/50 mb-4"
          autoFocus
          onKeyDown={e => {
            if (e.key === 'Enter' && name.trim()) onConfirm(name.trim());
          }}
        />
        <div className="flex gap-3">
          <button
            onClick={() => name.trim() && onConfirm(name.trim())}
            disabled={!name.trim()}
            className="flex items-center gap-1.5 px-4 py-2 bg-accent-primary/20 text-accent-primary rounded-lg text-sm font-medium disabled:opacity-50 hover:bg-accent-primary/30 transition-colors"
          >
            <Brain className="w-4 h-4" />
            Generuj bazę wiedzy
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 text-text-secondary text-sm hover:text-text-primary transition-colors"
          >
            Anuluj
          </button>
        </div>
      </div>
    </div>
  );
}
